// =============================================================================
// STREETSTICKER.COM — EGGSHELL CONFIGURATOR (US Edition)
// Namespaced under window.SSConfigurator to support multiple sections on page.
// Depends on: pricing.js (must be loaded before this file)
//
// Two ways an order goes into the cart:
//   * Standard size -> the matching Shopify variant (Shape / Size / Quantity),
//     quantity 1, real price. Prices come from Shopify (SSVariantData).
//   * Custom size   -> the helper product priced at $0.01, quantity = price in
//     cents ("cents-as-quantity"). Prices come from pricing.js.
// If the product has no real variants yet (legacy setup), everything uses the
// cents-as-quantity pattern on the product itself.
// =============================================================================

(function () {
  'use strict';

  window.SSConfigurator = window.SSConfigurator || {};

  window.SSConfigurator.boot = function (opts) {
    const { sectionId } = opts;
    const id = (suffix) => `${suffix}-${sectionId}`;
    const el = (suffix) => document.getElementById(id(suffix));

    // ----- STATE (default: square 2×2 in × 1000, or opts.defaultShape / opts.defaultSizeId) -----
    const defShape = (opts.defaultShape && PRICING.SHAPES[opts.defaultShape]) ? opts.defaultShape : 'square';
    const defSize = PRICING.SHAPES[defShape].sizes.find(sz => sz.id === opts.defaultSizeId) || PRICING.SHAPES[defShape].sizes[0];
    const STATE = {
      shape: defShape,
      sizeId: defSize.id,
      sizeW: defSize.w,
      sizeH: defSize.h,
      isCustom: false,
      qty: 1000,
      artworkMode: 'upload',
      uploadedFile: null,
      emailLater: false
    };

    // Round (diameter) and die cut (longest side) take one size value; they are
    // priced as the square around the sticker.
    const oneSide = shape => shape === 'round' || shape === 'diecut' || shape === 'square';
    const sizeFieldLabel = shape => shape === 'round' ? 'Diameter' : (shape === 'diecut' ? 'Longest side' : (shape === 'square' ? 'Side' : 'Width'));
    // Custom sizes of these shapes are priced in 0.5 in steps (rounded up).
    const STEP = PRICING.CUSTOM_STEP || 0.5;
    const snapUp = n => Math.ceil(n / STEP - 1e-9) * STEP;
    const fmtIn = n => String(Math.round(n * 10) / 10);
    const sizeOptionValue = (shape, n) => shape === 'round' ? `${fmtIn(n)} in` : `${fmtIn(n)} x ${fmtIn(n)} in`;
    const optionKey = (shape, n, qty) => PRICING.SHAPES[shape].label + '|' + sizeOptionValue(shape, n) + '|' + qty.toLocaleString('en-US') + ' pcs';
    const sizeText = () => oneSide(STATE.shape) ? `${STATE.sizeW} in` : `${STATE.sizeW} × ${STATE.sizeH} in`;

    // ----- DOM refs -----
    const els = {
      sizeGrid:       el('SSSizeGrid'),
      sizeHint:       el('SSSizeHint'),
      qtyGrid:        el('SSQtyGrid'),
      customW:        el('SSCustomW'),
      customH:        el('SSCustomH'),
      customApply:    el('SSCustomApply'),
      customFields:   el('SSCustomFields'),
      customHField:   el('SSCustomHField'),

      perUnit:        el('SSPerUnit'),
      total:          el('SSTotal'),
      ctaPrice:       el('SSCtaPrice'),
      savingsBadge:   el('SSSavings'),
      savingsPct:     el('SSSavingsPct'),
      savingsAbs:     el('SSSavingsAbs'),
      breakdown:      el('SSBreakdown'),
      minNote:        el('SSMinNote'),

      propShape:      el('SSPropShape'),
      propSize:       el('SSPropSize'),
      propArea:       el('SSPropArea'),
      propQty:        el('SSPropQty'),
      propPerUnit:    el('SSPropPerUnit'),
      propArtwork:    el('SSPropArtwork'),
      propPriceCents: el('SSPropPriceCents'),
      propConfigJson: el('SSPropConfigJson'),
      propWeight:     el('SSPropWeight'),
      propExact:      el('SSPropExact'),
      cartQty:        el('SSCartQuantity'),

      uploadInput:    el('SSUploadInput'),
      uploadLabel:    el('SSUploadLabel'),
      uploadFile:     el('SSUploadFile'),
      uploadFileName: el('SSUploadFileName'),
      uploadFileClear:el('SSUploadFileClear'),
      panelUpload:    el('SSPanelUpload'),
      panelEmail:     el('SSPanelEmail'),
      emailLater:     el('SSEmailLater'),

      pricetableGrid: el('SSPricetableGrid'),
      pricetableShape:el('SSPricetableShape'),

      stickyCta:       el('SSStickyCta'),
      stickyBreakdown: el('SSStickyBreakdown'),
      stickyPrice:     el('SSStickyPrice'),
      stickyPer:       el('SSStickyPer'),
      mainCta:         el('SSAddToCart'),

      galleryVideo:        el('SSGalleryVideo'),
      galleryVideoToggle:  el('SSGalleryVideoToggle'),
      galleryShapeImgs:    el('SSShapeImgs'),

      form:           document.getElementById(`SSConfigForm-${sectionId}`)
    };

    els.variantId = els.form ? els.form.querySelector('input[name="id"]') : null;

    // ----- VARIANT DATA (from Liquid) -----
    let VDATA = { legacy: true, customVariantId: null, variants: {} };
    try {
      const node = document.getElementById(`SSVariantData-${sectionId}`);
      if (node) VDATA = JSON.parse(node.textContent);
    } catch (e) { /* keep legacy defaults */ }
    // Accept "3 × 3 in" as well as "3 x 3 in" in the Shopify option values.
    if (VDATA.variants) {
      const normalized = {};
      Object.keys(VDATA.variants).forEach(k => { normalized[k.replace(/×/g, 'x')] = VDATA.variants[k]; });
      VDATA.variants = normalized;
    }
    const hasVariants = !VDATA.legacy && VDATA.variants && Object.keys(VDATA.variants).length > 0;
    const SIZE_VARIANTS = {};
    Object.keys(VDATA.sizeVariants || {}).forEach(k => { SIZE_VARIANTS[k.replace(/×/g, 'x')] = VDATA.sizeVariants[k]; });

    // Price quote for the current shape/size at a given quantity.
    function quote(qty) {
      if (hasVariants && !STATE.isCustom && typeof variantKey === 'function') {
        const key = variantKey(STATE.shape, STATE.sizeW, STATE.sizeH, qty);
        const v = key ? VDATA.variants[key] : null;
        if (v) {
          const total = v.price / 100;
          return { total, perUnit: total / qty, variantId: v.id, minimumApplied: false };
        }
      }
      if (STATE.isCustom && oneSide(STATE.shape)) {
        const ps = snapUp(STATE.sizeW);
        const key = optionKey(STATE.shape, ps, qty);
        const v = (hasVariants && VDATA.variants[key]) || SIZE_VARIANTS[key];
        if (v) {
          const total = v.price / 100;
          return { total, perUnit: total / qty, variantId: v.id, minimumApplied: false, priceSize: ps };
        }
        const p = priceFor(calcArea(STATE.shape, ps, ps), qty, STATE.shape);
        return { total: p.total, perUnit: p.discountedPerUnit, variantId: null, minimumApplied: p.floorActive, priceSize: ps };
      }
      const p = priceFor(calcArea(STATE.shape, STATE.sizeW, STATE.sizeH), qty, STATE.shape);
      return { total: p.total, perUnit: p.discountedPerUnit, variantId: null, minimumApplied: p.floorActive };
    }
    // Percent saved per sticker compared with the smallest tier.
    function savingsPct(qty) {
      const base = quote(PRICING.QUANTITY_TIERS[0].qty);
      const cur = quote(qty);
      return base.perUnit > 0 && cur.perUnit < base.perUnit ? (1 - cur.perUnit / base.perUnit) * 100 : 0;
    }

    // ----- GALLERY VIDEO TOGGLE -----
    if (els.galleryVideo && els.galleryVideoToggle && els.galleryShapeImgs) {
      els.galleryVideoToggle.addEventListener('click', () => {
        const showVideo = els.galleryVideo.hasAttribute('hidden');
        if (showVideo) {
          els.galleryVideo.hidden = false;
          els.galleryShapeImgs.style.visibility = 'hidden';
          els.galleryVideoToggle.setAttribute('aria-pressed', 'true');
          // Attempt to play; ignore promise rejection (autoplay policy)
          const v = els.galleryVideo.querySelector('video');
          if (v && typeof v.play === 'function') v.play().catch(() => {});
        } else {
          els.galleryVideo.hidden = true;
          els.galleryShapeImgs.style.visibility = '';
          els.galleryVideoToggle.setAttribute('aria-pressed', 'false');
          const v = els.galleryVideo.querySelector('video');
          if (v && typeof v.pause === 'function') v.pause();
        }
      });
    }

    // ----- STICKY CTA visibility — show when the main CTA scrolls off-screen -----
    // Move sticky-cta directly to <body> so no transformed/overflowed parent
    // can clip or restrict its fixed positioning.
    if (els.stickyCta && els.stickyCta.parentNode !== document.body) {
      document.body.appendChild(els.stickyCta);
    }
    if (els.stickyCta && els.mainCta && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // Hide sticky when the main CTA is in view, show when it's out of view.
          els.stickyCta.classList.toggle('is-visible', !entry.isIntersecting);
          els.stickyCta.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
        });
      }, {
        threshold: 0.05,
        rootMargin: '0px 0px -60px 0px' // trigger slightly before fully off-screen
      });
      io.observe(els.mainCta);
    }

    // ----- SHAPES -----
    const section = document.getElementById(`ProductConfigurator-${sectionId}`);
    section.querySelectorAll('.ss-shape').forEach(btn => {
      btn.addEventListener('click', () => selectShape(btn.dataset.shape));
    });

    function selectShape(shape) {
      STATE.shape = shape;
      section.querySelectorAll('.ss-shape').forEach(btn => {
        btn.setAttribute('aria-checked', btn.dataset.shape === shape ? 'true' : 'false');
      });
      // Swap shape-specific gallery image
      section.querySelectorAll('[data-shape-img]').forEach(imgDiv => {
        imgDiv.hidden = imgDiv.dataset.shapeImg !== shape;
      });
      if (!STATE.isCustom) {
        const first = PRICING.SHAPES[shape].sizes[0];
        STATE.sizeId = first.id; STATE.sizeW = first.w; STATE.sizeH = first.h;
      }
      if (oneSide(shape) && STATE.isCustom) STATE.sizeH = STATE.sizeW;
      els.customFields.classList.toggle('is-round', oneSide(shape));
      const lbl = els.customFields.querySelector('.ss-custom-size__field-label');
      if (lbl) lbl.textContent = sizeFieldLabel(shape);
      renderSizes(); renderAll();
    }

    // ----- SIZES -----
    function renderSizes() {
      // Shape-specific note under the sizes (e.g. die cut: size = longest side)
      section.querySelectorAll('.ss-size-note[data-shape]').forEach(n => { n.hidden = n.dataset.shape !== STATE.shape; });
      const shape = PRICING.SHAPES[STATE.shape];
      els.sizeGrid.innerHTML = '';
      shape.sizes.forEach(size => {
        const area = calcArea(STATE.shape, size.w, size.h);
        const checked = !STATE.isCustom && STATE.sizeId === size.id;
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', checked ? 'true' : 'false');
        const sub = STATE.shape === 'diecut' ? 'longest side' : `${area.toFixed(1)} in²`;
        btn.innerHTML = `<span class="ss-size__label">${size.label}</span><span class="ss-size__area">${sub}</span>`;
        btn.addEventListener('click', () => {
          STATE.isCustom = false; STATE.sizeId = size.id;
          STATE.sizeW = size.w; STATE.sizeH = size.h;
          renderSizes(); renderAll();
        });
        els.sizeGrid.appendChild(btn);
      });
      if (STATE.isCustom) {
        const lbl = sizeText();
        const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-size ss-size--custom';
        btn.setAttribute('aria-checked', 'true'); btn.setAttribute('role', 'radio');
        btn.innerHTML = `<span class="ss-size__label">${lbl}</span><span class="ss-size__area">${STATE.shape === 'diecut' ? 'longest side' : area.toFixed(1) + ' in²'} · custom</span>`;
        els.sizeGrid.appendChild(btn);
      }
      if (els.sizeHint) els.sizeHint.textContent = STATE.isCustom ? 'Custom size' : 'Standard sizes';
    }

    // ----- CUSTOM SIZE -----
    els.customApply.addEventListener('click', applyCustom);
    [els.customW, els.customH].forEach(inp => {
      inp.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); applyCustom(); } });
      inp.addEventListener('input', () => inp.classList.remove('is-invalid'));
    });

    function applyCustom() {
      const min = PRICING.CUSTOM_MIN_IN, max = PRICING.CUSTOM_MAX_IN;
      let w = parseFloat(els.customW.value);
      let h = oneSide(STATE.shape) ? w : parseFloat(els.customH.value);
      let valid = true;
      if (!Number.isFinite(w) || w < min || w > max) { els.customW.classList.add('is-invalid'); valid = false; }
      if (!oneSide(STATE.shape) && (!Number.isFinite(h) || h < min || h > max)) {
        els.customH.classList.add('is-invalid'); valid = false;
      }
      if (!valid) return;
      STATE.isCustom = true; STATE.sizeId = 'custom';
      STATE.sizeW = Math.round(w * 10) / 10; STATE.sizeH = Math.round(h * 10) / 10;
      renderSizes(); renderAll();
      const det = els.customApply.closest('details');
      if (det) det.open = false;
    }

    // ----- QTY -----
    function renderQty() {
      els.qtyGrid.innerHTML = '';
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const q = quote(tier.qty);
        const pct = Math.round(savingsPct(tier.qty));
        const checked = STATE.qty === tier.qty;
        const isPopular = tier.qty === PRICING.POPULAR_QTY;
        const btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'ss-qty' + (isPopular ? ' ss-qty--popular' : '');
        btn.setAttribute('role', 'radio'); btn.setAttribute('aria-checked', checked ? 'true' : 'false');
        btn.innerHTML = `
          <span class="ss-qty__count">${tier.qty.toLocaleString('en-US')}</span>
          <span class="ss-qty__total">${fmtUSD(q.total)}</span>
          <span class="ss-qty__per">${fmtUSDcents(q.perUnit)} each${pct > 0 ? ` <span class="ss-qty__save">−${pct}%</span>` : ''}</span>
          ${isPopular ? '<span class="ss-qty__tag">Most ordered</span>' : ''}
        `;
        btn.addEventListener('click', () => { STATE.qty = tier.qty; renderQty(); renderAll(); });
        els.qtyGrid.appendChild(btn);
      });
    }

    // ----- ARTWORK -----
    section.querySelectorAll('.ss-artwork-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const mode = tab.dataset.tab;
        STATE.artworkMode = mode;
        section.querySelectorAll('.ss-artwork-tab').forEach(t => {
          const a = t.dataset.tab === mode;
          t.classList.toggle('ss-artwork-tab--active', a);
          t.setAttribute('aria-selected', a ? 'true' : 'false');
        });
        els.panelUpload.hidden = mode !== 'upload';
        els.panelEmail.hidden = mode !== 'email';
      });
    });

    els.uploadInput.addEventListener('change', e => {
      const file = e.target.files[0]; if (!file) return;
      if (file.size > 20 * 1024 * 1024 - 4096) { // Shopify-Limit 20 MiB, Reserve für die ZIP-Hülle (upload-original.js)
        els.uploadFileName.textContent = 'That file is over 20 MB. Please send it by email instead.';
        els.uploadFile.hidden = false;
        els.uploadInput.value = ''; STATE.uploadedFile = null; return;
      }
      STATE.uploadedFile = file;
      els.uploadFileName.textContent = `${file.name} · ${(file.size/1024/1024).toFixed(2)} MB`;
      els.uploadFile.hidden = false;
    });
    els.uploadFileClear.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      STATE.uploadedFile = null; els.uploadInput.value = ''; els.uploadFile.hidden = true;
    });
    ['dragenter','dragover'].forEach(ev => els.uploadLabel.addEventListener(ev, e => {
      e.preventDefault(); els.uploadLabel.classList.add('is-drag');
    }));
    ['dragleave','drop'].forEach(ev => els.uploadLabel.addEventListener(ev, e => {
      e.preventDefault(); els.uploadLabel.classList.remove('is-drag');
    }));
    els.uploadLabel.addEventListener('drop', e => {
      e.preventDefault();
      const f = e.dataTransfer.files[0];
      if (f) { els.uploadInput.files = e.dataTransfer.files; els.uploadInput.dispatchEvent(new Event('change')); }
    });
    els.emailLater.addEventListener('change', e => { STATE.emailLater = e.target.checked; });

    // ----- PRICE -----
    function renderPrice() {
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const q = quote(STATE.qty);
      const pct = Math.round(savingsPct(STATE.qty));
      const useVariant = !!q.variantId;
      const canOrder = useVariant || !!VDATA.customVariantId;
      STATE.canOrder = canOrder;
      const sizeStr = sizeText();
      const shapeLabel = PRICING.SHAPES[STATE.shape].label;
      const pricedAs = STATE.isCustom && q.priceSize && Math.abs(q.priceSize - STATE.sizeW) > 0.001;
      const pricedAsTxt = pricedAs ? ` (priced as ${fmtIn(q.priceSize)} in)` : '';

      els.perUnit.textContent  = fmtUSDcents(q.perUnit);
      els.total.textContent    = fmtUSD(q.total);
      els.ctaPrice.textContent = fmtUSD(q.total);
      els.breakdown.textContent = canOrder
        ? `${STATE.qty.toLocaleString('en-US')} × ${shapeLabel.toLowerCase()} ${sizeStr}${pricedAsTxt}, ${fmtUSDcents(q.perUnit)} each. Shipping included, no extra fees.`
        : 'For this size, email us at hello@streetsticker.com and we will set up your order.';
      if (els.mainCta) els.mainCta.disabled = !canOrder;
      const stickyBtn = els.stickyCta ? els.stickyCta.querySelector('button') : null;
      if (stickyBtn) stickyBtn.disabled = !canOrder;

      // Update sticky-bottom-bar values
      if (els.stickyPrice)     els.stickyPrice.textContent     = fmtUSD(q.total);
      if (els.stickyPer)       els.stickyPer.textContent       = `${fmtUSDcents(q.perUnit)} each`;
      if (els.stickyBreakdown) els.stickyBreakdown.textContent = `${STATE.qty.toLocaleString('en-US')} × ${shapeLabel} ${sizeStr}`;

      // Minimum order notice
      if (els.minNote) els.minNote.hidden = !q.minimumApplied;

      if (pct > 0) {
        els.savingsBadge.classList.remove('is-zero');
        els.savingsPct.textContent = `${pct}% less per sticker`;
        els.savingsAbs.textContent = `than at ${PRICING.QUANTITY_TIERS[0].qty.toLocaleString('en-US')} pcs`;
      } else {
        els.savingsBadge.classList.add('is-zero');
        els.savingsPct.textContent = '';
        els.savingsAbs.textContent = '';
      }

      // Update hidden form fields for Shopify cart submission.
      // Standard size: real variant, quantity 1. Custom size: helper product at
      // $0.01, quantity = total in cents (cents-as-quantity).
      const totalCents = Math.round(q.total * 100);
      if (els.variantId && (useVariant || VDATA.customVariantId)) {
        els.variantId.value = useVariant ? q.variantId : VDATA.customVariantId;
      }
      if (els.cartQty)        els.cartQty.value        = useVariant ? 1 : totalCents;
      // Variant lines carry shape/size/qty in the variant title and the weight
      // on the variant, so only the cents-line properties are switched off.
      [els.propShape, els.propSize, els.propArea, els.propQty, els.propPerUnit, els.propPriceCents, els.propWeight]
        .forEach(inp => { if (inp) inp.disabled = useVariant; });
      if (els.propExact) {
        els.propExact.disabled = !(useVariant && pricedAs);
        els.propExact.value = pricedAs ? sizeStr : '';
      }
      if (els.propShape)      els.propShape.value      = shapeLabel;
      if (els.propSize)       els.propSize.value       = sizeStr;
      if (els.propArea)       els.propArea.value       = `${area.toFixed(1)} in²`;
      if (els.propQty)        els.propQty.value        = STATE.qty.toLocaleString('en-US');
      if (els.propPerUnit)    els.propPerUnit.value    = fmtUSDcents(q.perUnit);
      if (els.propPriceCents) els.propPriceCents.value = totalCents.toString();
      const weightG = (typeof estimateWeightGrams === 'function')
        ? estimateWeightGrams(STATE.shape, STATE.sizeW, STATE.sizeH, STATE.qty) : 0;
      if (els.propWeight)     els.propWeight.value     = weightG ? `approx. ${(weightG / 1000).toFixed(2)} kg` : '';
      if (els.propConfigJson) els.propConfigJson.value = JSON.stringify({
        shape: STATE.shape, sizeW: STATE.sizeW, sizeH: STATE.sizeH,
        qty: STATE.qty, totalUSD: q.total, weightG, variantId: q.variantId, priceSize: q.priceSize || null
      });
    }

    // ----- PRICE TABLE -----
    function renderPriceTable() {
      const area = calcArea(STATE.shape, STATE.sizeW, STATE.sizeH);
      const sizeStr = sizeText();
      if (els.pricetableShape) els.pricetableShape.textContent = `${PRICING.SHAPES[STATE.shape].label.toLowerCase()}, ${sizeStr}`;
      if (!els.pricetableGrid) return;
      els.pricetableGrid.innerHTML = '';
      PRICING.QUANTITY_TIERS.forEach(tier => {
        const q = quote(tier.qty);
        const pct = Math.round(savingsPct(tier.qty));
        const active = tier.qty === STATE.qty;
        const row = document.createElement('tr');
        row.className = 'ss-pricetable__row' + (active ? ' is-active' : '');
        row.tabIndex = 0;
        row.innerHTML = `<td>${tier.qty.toLocaleString('en-US')}</td><td>${fmtUSDcents(q.perUnit)}</td><td>${pct > 0 ? `−${pct}%` : '–'}</td><td>${fmtUSD(q.total)}</td>`;
        const pick = () => { STATE.qty = tier.qty; renderAll(); };
        row.addEventListener('click', pick);
        row.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
        els.pricetableGrid.appendChild(row);
      });
    }

    // ----- FORM SUBMIT: artwork property -----
    if (els.form) {
      els.form.addEventListener('submit', (e) => {
        if (STATE.canOrder === false) { e.preventDefault(); return; }
        const artworkVal = STATE.artworkMode === 'upload'
          ? (STATE.uploadedFile ? STATE.uploadedFile.name : 'File to follow')
          : 'By email to hello@streetsticker.com';
        if (els.propArtwork) els.propArtwork.value = artworkVal;
      });
    }

    function renderAll() { renderQty(); renderPrice(); renderPriceTable(); }

    // ----- INIT -----
    // Optional preselection from the URL, e.g. links from the homepage packs:
    // /products/custom-eggshell-stickers?shape=round&w=3&h=3&qty=1000
    (function applyUrlPreset() {
      let params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }

      // ?variant=123 (Google Shopping, links to a specific variant)
      const variantParam = params.get('variant');
      if (variantParam && hasVariants) {
        const key = Object.keys(VDATA.variants).find(k => String(VDATA.variants[k].id) === variantParam);
        if (key) {
          const [shapeLabel, sizeLabel, qtyLabel] = key.split('|');
          const shapeId = Object.keys(PRICING.SHAPES).find(id => PRICING.SHAPES[id].label === shapeLabel);
          const size = shapeId && PRICING.SHAPES[shapeId].sizes.find(sz => (sz.key || sz.label.replace('×', 'x')) === sizeLabel);
          const qty = parseInt(qtyLabel.replace(/[^0-9]/g, ''), 10);
          if (shapeId && size) {
            params.set('shape', shapeId); params.set('w', size.w); params.set('h', size.h); params.set('qty', qty);
          }
        }
      }

      const shape = params.get('shape');
      if (shape && PRICING.SHAPES[shape]) {
        STATE.shape = shape;
        section.querySelectorAll('.ss-shape').forEach(btn => {
          btn.setAttribute('aria-checked', btn.dataset.shape === shape ? 'true' : 'false');
        });
        section.querySelectorAll('[data-shape-img]').forEach(imgDiv => {
          imgDiv.hidden = imgDiv.dataset.shapeImg !== shape;
        });
        els.customFields.classList.toggle('is-round', oneSide(shape));
        const first = PRICING.SHAPES[shape].sizes[0];
        STATE.sizeId = first.id; STATE.sizeW = first.w; STATE.sizeH = first.h;
      }
      const w = parseFloat(params.get('w'));
      const h = oneSide(STATE.shape) ? w : parseFloat(params.get('h'));
      if (Number.isFinite(w) && Number.isFinite(h) &&
          w >= PRICING.CUSTOM_MIN_IN && w <= PRICING.CUSTOM_MAX_IN &&
          h >= PRICING.CUSTOM_MIN_IN && h <= PRICING.CUSTOM_MAX_IN) {
        const std = PRICING.SHAPES[STATE.shape].sizes.find(sz =>
          (sz.w === w && sz.h === h) || (sz.w === h && sz.h === w));
        if (std) {
          STATE.isCustom = false; STATE.sizeId = std.id; STATE.sizeW = std.w; STATE.sizeH = std.h;
        } else {
          STATE.isCustom = true; STATE.sizeId = 'custom'; STATE.sizeW = w; STATE.sizeH = h;
        }
      }
      const qty = parseInt(params.get('qty'), 10);
      if (PRICING.QUANTITY_TIERS.some(t => t.qty === qty)) STATE.qty = qty;
    })();

    els.customFields.classList.toggle('is-round', oneSide(STATE.shape));
    const sizeLbl = els.customFields.querySelector('.ss-custom-size__field-label');
    if (sizeLbl) sizeLbl.textContent = sizeFieldLabel(STATE.shape);

    renderSizes(); renderAll();
  };

})();
